import { booleanAttribute, ChangeDetectionStrategy, Component, ElementRef, inject, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DsAutosuggestModule, DsFormFieldModule, DsIconModule } from '@bmw-ds/components';

import { InputFieldComponent } from '../input-field/input-field.component';

@Component({
  selector: 'cdf-input-phone-number',
  imports: [DsFormFieldModule, FormsModule, DsAutosuggestModule, DsIconModule, InputFieldComponent],
  template: `
    <cdf-input-field
      [id]="id()"
      [placeholder]="placeholder() ?? ''"
      [attr.title]="title()"
      [model]="model()"
      (modelChange)="updateModel($event)"
      [displayError]="displayError()"
      [errorMessage]="errorMessage()"
      [maxLength]="maxLength()"
      [disabled]="disabled()"
      [validateWhenTouchedOnly]="validateWhenTouchedOnly()"
    />
  `,
  styleUrl: './input-phone-number.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputPhoneNumberComponent {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly model = model<string>();
  readonly id = input.required<string>();
  readonly placeholder = input<string>();

  readonly displayError = input(false);
  readonly errorMessage = input<string>();
  readonly title = input<string>();
  readonly maxLength = input<number>();

  readonly disabled = input(false, { transform: booleanAttribute });
  readonly validateWhenTouchedOnly = input(false, { transform: booleanAttribute });

  async updateModel(value: string | undefined) {
    if (!value) {
      this.model.set(value);
      return;
    }

    const inputEl = this.el.nativeElement.querySelector('input');
    const cursorPosition = inputEl?.selectionStart ?? null;

    let newValue = value;
    if (value.startsWith('00')) {
      newValue = '+' + value.substring(2);
    } else if (/^[1-9]/.test(value)) {
      newValue = '+' + value;
    }

    const newCursorPosition = cursorPosition !== null ? cursorPosition - value.length + newValue.length : null;

    if (newValue === this.model() && newValue !== value) {
      this.model.set(value);
      await new Promise((resolve) => setTimeout(resolve));
    }
    this.model.set(newValue);
    if (newCursorPosition !== null) {
      await new Promise((resolve) => setTimeout(resolve));
      inputEl?.setSelectionRange(newCursorPosition, newCursorPosition);
    }
  }
}
